import { useState } from "react";
import { navLinks } from "@/mocks/home";
import { showToast } from "@/hooks/useToast";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1240px] items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="font-sans flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-sm font-bold text-background-50">
            88
          </span>
          <h1 className="font-heading text-xl font-bold tracking-wide text-foreground-950">
            看料
          </h1>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="站内导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => showToast("内部通道已为你保留，本期直达码已复制")}
            className="hidden rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:block whitespace-nowrap"
          >
            进入内部通道
          </button>
          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="展开导航菜单"
            aria-expanded={menuOpen}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex w-full max-w-[1240px] flex-col px-4 py-2" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-200/70 py-3 text-sm text-foreground-700 last:border-none"
              >
                {link.label}
                <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line" aria-hidden="true" />
                </span>
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}